import { ADMIN } from 'components/RoleGate/constants';
import RoleModal from 'components/RoleModal';
import React from 'react';
import { Modal } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { updateQueryString } from 'services/router/actions';
import ImportPeopleForm from './components/ImportPeopleForm';

export const IMPORT_PEOPLE_MODAL = 'IMPORT_PEOPLE_MODAL';

function ImportPeopleModal(): React.ReactElement {
    const dispatch = useDispatch();

    const handleOnClose = (): void => {
        dispatch(
            updateQueryString({
                [IMPORT_PEOPLE_MODAL]: undefined
            })
        );
    };

    return (
        <RoleModal
            param={IMPORT_PEOPLE_MODAL}
            requiredRoles={[ADMIN]}
            size="fullscreen"
        >
            <React.Fragment>
                <Modal.Header>Import people</Modal.Header>
                <Modal.Content className="constrain-width">
                    <ImportPeopleForm onClose={handleOnClose} />
                </Modal.Content>
            </React.Fragment>
        </RoleModal>
    );
}

export default ImportPeopleModal;
